var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2 capitalize",attrs:{"color":_vm.mode.color,"dark":""}},[(_vm.isConnected)?[_vm._v(" "+_vm._s(_vm.$t(_vm.mode.name)))]:_c('v-icon',[_vm._v("mdi-cloud-off-outline")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }